import React from "react";
import AdminStatCard from "./AdminStatCard";
import { CHERUB_COLORS } from "@/config/colors";

const AdminCherubStatCard = (props) => (
  <AdminStatCard
    gradientFrom="#075985"
    gradientTo={CHERUB_COLORS.SKY_DARK}
    borderColor={CHERUB_COLORS.SKY_MID}
    titleColor="white"
    valueColor="white"
    iconGhostColor="white"
    {...props}
  />
);

export default AdminCherubStatCard;
